module.exports = __webpack_public_path__ + "KaTeX_Size1-Regular.daf6d30b.woff2";